import PropTypes from 'prop-types';
import {createContext} from 'react';

// ==============================|| HARDWARE CATALOG CONTEXT & PROVIDER ||============================== //

const HardwareCatalogContext = createContext(null);

export const HardwareCatalogProvider = ({hardwareCatalogClientRef, children}) => {
    const getAll = (entityType, columnFiltersQuery = null, globalFilter = null, sortQuery = null, pageNumber = 0, pageSize = 99_999) => {
        return hardwareCatalogClientRef?.getAll(entityType, columnFiltersQuery, globalFilter, sortQuery, pageNumber, pageSize);
    }

    const getById = (entityType, entityId) => {
        return hardwareCatalogClientRef?.getById(entityType, entityId);
    }

    const create = (entityType, entity) => {
        return hardwareCatalogClientRef?.create(entityType, clearBlanks(entity));
    }

    const update = (entityType, entity) => {
        return hardwareCatalogClientRef?.update(entityType, clearBlanks(entity));
    }

    const remove = (entityType, entityId) => {
        return hardwareCatalogClientRef?.remove(entityType, entityId);
    }

    const getAllEnums = () => {
        return hardwareCatalogClientRef?.getAllEnums();
    }

    return <HardwareCatalogContext.Provider value={{getAll, getById, create, update, remove, getAllEnums}}>{children}</HardwareCatalogContext.Provider>;
}

HardwareCatalogProvider.propTypes = {
    hardwareCatalogClientRef: PropTypes.object.isRequired,
    children: PropTypes.node
};

function clearBlanks(entity) {
    for (const key in entity) {
        if (entity[key] === '') {
            entity[key] = null;
        } else if (Array.isArray(entity[key])) {
            entity[key] = entity[key].map(item => item === '' ? null : item);
        }
    }
    return entity;
}

export default HardwareCatalogContext;
